import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { AuthField, AuthLayout, AuthSubmit, AuthSuccess } from "./AuthLayout";

function looksLikeEmail(v: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());
}

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [touched, setTouched] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const emailError = touched && !looksLikeEmail(email) ? "Enter a valid email address." : null;

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setTouched(true);
    if (!looksLikeEmail(email)) return;
    setSubmitting(true);
    // Backend always returns 204 regardless of whether the email
    // exists (no enumeration). We just flip to the "sent" state —
    // and deliberately do so even when the request failed, so a
    // network error cannot be read as "this address is unknown".
    try {
      await api.post("/auth/forgot-password", { email });
    } finally {
      setSent(true);
      setSubmitting(false);
    }
  }

  return (
    <AuthLayout
      title="Reset your password"
      subtitle="Enter your email and we'll send you a link to set a new password."
    >
      {sent ? (
        <AuthSuccess title="Check your email">
          <p>
            If an account exists for that address, we&apos;ve sent a link to reset your
            password.
          </p>
          {/* Пятнадцать минут — это `PASSWORD_RESET_TTL_MINUTES` на
              сервере. Раньше здесь стоял «один час», а в письме «60
              минут», при живущем пятнадцать минут токене. */}
          <p>The link is valid for 15 minutes.</p>
        </AuthSuccess>
      ) : (
        <form className="au-card" onSubmit={onSubmit} noValidate>
          <AuthField
            id="forgot-email"
            label="Email"
            type="email"
            value={email}
            onChange={setEmail}
            autoComplete="username"
            placeholder="you@company.com"
            disabled={submitting}
            error={emailError}
          />
          <AuthSubmit busy={submitting} busyLabel="Sending">
            Send reset link
          </AuthSubmit>
        </form>
      )}
      <div className="au-links">
        <Link to="/login">Back to log in</Link>
      </div>
    </AuthLayout>
  );
}
